import { useMemo } from "react";
import { useTable } from "react-table";
import PropTypes from "prop-types";

import FlexContainers from "../../../Containers/FlexContainers";
import Table from "../../../Table/Table";

import { ImportedRecordsTableWrapper } from "./styled";

const ImportedRecordsTable = ({ records = [], ImportedRecordsTableColumns }) => {
  const data = useMemo(() => records, [records]);
  const columns = useMemo(() => ImportedRecordsTableColumns, []);

  const tableInstance = useTable({
    columns,
    data
  });

  return (
    <ImportedRecordsTableWrapper Container={FlexContainers.FlexColumnStart} width="100%">
      <Table tableInstance={tableInstance} />
    </ImportedRecordsTableWrapper>
  );
};

ImportedRecordsTable.propTypes = {
  records: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      correct: PropTypes.bool.isRequired
    }).isRequired
  ),
  ImportedRecordsTableColumns: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired
};

export default ImportedRecordsTable;
